'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiError = exports.GENERIC_ERROR = exports.isBillingError = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _freeze = require('babel-runtime/core-js/object/freeze');

var _freeze2 = _interopRequireDefault(_freeze);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isBillingError = exports.isBillingError = function isBillingError(error) {
  return error && error.code >= 4301 && error.code <= 4320;
};

// NOTE: this is a hack so that sagas can universally represent the generic error message
var GENERIC_ERROR = exports.GENERIC_ERROR = (0, _freeze2.default)({ isGenericError: true });

var ApiError = exports.ApiError = function (_Component) {
  (0, _inherits3.default)(ApiError, _Component);

  function ApiError() {
    (0, _classCallCheck3.default)(this, ApiError);
    return (0, _possibleConstructorReturn3.default)(this, (ApiError.__proto__ || (0, _getPrototypeOf2.default)(ApiError)).apply(this, arguments));
  }

  (0, _createClass3.default)(ApiError, [{
    key: 'errors',
    value: function errors() {
      var _props = this.props,
          errors = _props.errors,
          error = _props.error;


      return (errors || []).concat(error).filter(function (err) {
        return !!err;
      });
    }
  }, {
    key: 'surfacedErrorCodes',
    value: function surfacedErrorCodes() {
      var _props2 = this.props,
          surfacedErrorCodes = _props2.surfacedErrorCodes,
          surfacedErrorCode = _props2.surfacedErrorCode;


      return (surfacedErrorCodes || []).concat(surfacedErrorCode).filter(function (code) {
        return !!code;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          extraClasses = _props3.extraClasses,
          reduce = _props3.reduce;


      var errors = this.errors();
      var codes = this.surfacedErrorCodes();

      if (!errors.length) {
        return false;
      }

      return _react2.default.createElement(
        'div',
        { className: 'error__text ' + (extraClasses || '') },
        ApiError.messageForDisplay(errors, reduce, codes)
      );
    }
  }], [{
    key: 'billingErrorReducer',
    value: function billingErrorReducer(memo, error) {
      if (error && (error.code === 4608 || isBillingError(error))) {
        return error;
      }

      return memo;
    }
  }, {
    key: 'extractMessage',
    value: function extractMessage(error) {
      if (typeof error === 'string') {
        return error;
      }

      if (error && error.code === 4608) {
        return _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'api-error.suspect',
          defaultMessage: 'Your promotion cannot be activated because you\u2019ve previously had an active ClassPass account. <a href=\'/pricing\'>See Plans</a> or <a href=\'/contact\'>Contact Us</a> for help.'
        });
      }

      if (error && [4313, 4314, 4315].includes(error.code)) {
        return _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'api-error.billing-error',
          defaultMessage: 'There was a problem processing your request. Please provide a valid payment method to continue.'
        });
      }

      if (error && error.message) {
        return error.message;
      }

      if (error && error.details) {
        return error.details;
      }

      return _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: 'api-error.generic-message',
        defaultMessage: 'Uh oh! Something unexpected occurred. We were not able to process your request. Please <a target=\'_blank\' rel=\'noopener noreferrer\' href=\'/contact\'>reach out to us</a> and we\u2019ll help you keep moving.'
      });
    }
  }, {
    key: 'messageForDisplay',
    value: function messageForDisplay(errors, reducer) {
      var codes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      var reducerToUse = reducer || function (memo, err) {
        return codes.indexOf(err.code) !== -1 ? err : memo;
      };
      var error = (errors || []).reduce(reducerToUse, null);
      return ApiError.extractMessage(error);
    }
  }]);
  return ApiError;
}(_react.Component);

var errorShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.bool]);

ApiError.propTypes = {
  error: errorShape,
  errors: _propTypes2.default.arrayOf(errorShape),
  extraClasses: _propTypes2.default.string,
  reduce: _propTypes2.default.func,
  surfacedErrorCode: _propTypes2.default.number,
  surfacedErrorCodes: _propTypes2.default.arrayOf(_propTypes2.default.number)
};